<style src="css/index.css" scoped></style>
<style >
.wh_indicator .wh_indicator_item {
  width: 0.08rem;
  height: 0.08rem;
  background: #ffffff;
  opacity: 0.5;
  border-radius: 50%;
}

.wh_indicator .wh_show_bgcolor {
  width: 0.28rem;
  height: 0.08rem;
  background: #ffffff;
  opacity: 0.9;
  border-radius: 0.08rem;
}
</style>
<template>
  <div class="containerBox" style="padding-top: 1.4rem">
    <newsTopBox title=""></newsTopBox>
    <div class="topBox">
      <Swiper
        class="bannerBox"
        v-if="microBannerList.length > 0"
        :autoPlay="true"
        interval="2500"
        duration="500"
      >
        <Slide
          class="banner"
          @click="clickMe(item.picUrl)"
          :style="{
            background: `url(${EnvUrl + item.pic}) no-repeat center/cover`,
          }"
          v-for="(item, index) in microBannerList"
          :key="index"
        >
          <!--&lt;!&ndash;//添加click事件&ndash;&gt;{{index}}-->
        </Slide>
      </Swiper>
      <!--            <Swiper class="bannerBox" :autoPlay='true'>-->
      <!--                <Slide class="banner"></Slide>-->
      <!--                <Slide class="banner"></Slide>-->
      <!--            </Swiper>-->
      <div class="tabBox">
        <div class="tab" @click="gotoUsOnline()">
          <div class="tIcon t1"></div>
          在线疏导
        </div>
        <div class="tab" @click="telDredge()">
          <div class="tIcon t2"></div>
          电话疏导
        </div>

        <div class="tab" @click="gotoCulinarian()">
          <div class="tIcon t5"></div>
          心理咨询
        </div>

        <div class="tab" @click="gotoMiyou">
          <div class="tIcon t4"></div>
          AI慧语心理
        </div>
        <!--                <div class="tab" @click="to('activityCenter')">-->
        <!--                    <div class="tIcon t3"></div>-->
        <!--                    活动-->
        <!--                </div>-->
      </div>
    </div>
    <!--        <div class="box" style="margin-top: .3rem;margin-bottom: 0" @click="to(`mentalExperience?comboId=${scaleGroupCombo.comboId}`)" v-if="showScaleGroup">-->
    <!--            <div class="correctTop">-->
    <!--                <div class="correctNotice">-->
    <!--                    <div class="correctIcon"></div>-->
    <!--                    通知-->
    <!--                </div>-->
    <!--                {{scaleGroupCombo.createTime | month}}-->
    <!--            </div>-->
    <!--            <div class="correctBottom">-->
    <!--                <div class="picBox">-->
    <!--                    <img :src="EnvUrl + scaleGroup.pic" alt="">-->
    <!--                    <div class="correctTitleBox">-->
    <!--                        <div class="correctTitle">{{scaleGroup.title}}</div>-->
    <!--                        <div class="correctTime">{{scaleGroupCombo.testTimes==0?'首次测试':'量表测试'}}</div>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--                <div class="completeStatus">{{scaleGroupCombo.testStatus==0?'未完成':'已完成'}}</div>-->
    <!--            </div>-->

    <!--        </div>-->
    <div class="fmBox" @click="to(`music?musicId=${musicList[0].musicId}`)">
      <div class="fmLeft">
        <div class="fmTitle" v-if="musicList.length > 0">
          {{ musicList[0].name }}
        </div>
        <div class="fmIconBox">倾听 | 疏导</div>
      </div>
      <div class="fmRight">
        <div class="toIcon"></div>
      </div>
    </div>
    <div class="box">
      <div class="titleBox" style="margin-bottom: 0.32rem">
        情绪健康
        <div class="moreBox" @click="to('ask')">
          更多
          <div class="moreIcon"></div>
        </div>
      </div>
      <div class="reducibleList">
        <div
          class="reducibleItem"
          :class="{ active: !bespeakAbled }"
          @click="changeBespeakAbled(0)"
        >
          情绪管理师
        </div>
        <div
          class="reducibleItem"
          :class="{ active: bespeakAbled }"
          @click="changeBespeakAbled(1)"
        >
          可预约情绪管理
        </div>
      </div>
      <div class="reducibleList">
        <div
          class="reducibleItem"
          :class="{ active: campusLocation == item }"
          v-for="item in doctorCampusList"
          @click="changeCampusLocation(item)"
        >
          {{ item }}
        </div>
      </div>
      <div
        class="expertItem"
        v-for="item in doctorList"
        @click="to(`expertDetail?doctorId=${item.doctorId}`)"
      >
        <img class="expertLeft" :src="EnvUrl + item.doctorWorkPhoto" alt="" />
        <!--                <div class="expertLeft" :style="{background: `url(${EnvUrl+item.doctorWorkPhoto}) no-repeat center/cover`}">-->
        <!--                    <div class="doctorHospital">{{item.doctorHospital}}</div>-->
        <!--                  </div>-->
        <div class="expertRight">
          <div class="nameBox">
            <div class="name">{{ item.doctorName }}</div>
            <div class="licenseName">{{ item.doctorHospitalLevel }}</div>
          </div>

          <div class="good">
            咨询师介绍：<span v-html="item.doctorProfile"></span>
          </div>
          <div class="expertTabBox">
            <div class="tabItem" v-if="item.chatDoctorServe.video">
              {{ item.chatDoctorServe.video ? "视频咨询" : "" }}
              <!--                            服务人数{{item.honor}}-->
            </div>
            <div class="tabItem" v-if="item.chatDoctorServe.telephone">
              {{ item.chatDoctorServe.telephone ? "语音咨询" : "" }}
            </div>
            <div class="tabItem" v-if="item.chatDoctorServe.imageText">
              {{ item.chatDoctorServe.imageText ? "图文咨询" : "" }}
              <!--                            好评率{{item.starRate}}%-->
            </div>
            <div class="tabItem" v-if="item.chatDoctorServe.offline">
              {{ item.chatDoctorServe.offline ? "线下咨询" : "" }}
            </div>
          </div>
          <div
            style="margin-top: 0.16rem; font-size: 0.28rem"
            v-if="item.chatDoctorServe.remark && item.chatDoctorServe.offline"
          >
            线下地址：{{ item.chatDoctorServe.remark }}
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="titleBox">
        精品好课
        <div class="moreBox" @click="to(`courseList`)">
          更多
          <div class="moreIcon"></div>
        </div>
      </div>
      <ul class="excellentCourses">
        <li
          @click="to(`courseDetail?microId=${item.microId}`)"
          v-for="item in microList"
        >
          <div
            class="courseImg"
            :style="{ background: `url(${item.pic}) no-repeat center/cover` }"
          >
            <!--                        <div class="free">免费</div>-->
          </div>
          <div class="timeBox">
            <span>{{ item.readCount }}已看</span>
            <span>{{ item.duration | isDuration }} </span>
          </div>
          <div class="courseTitle">{{ item.name }}</div>
        </li>
      </ul>
    </div>
    <div class="box">
      <div class="titleBox">
        推荐好文
        <div class="moreBox" @click="to('articleList')">
          更多
          <div class="moreIcon"></div>
        </div>
      </div>
      <ul class="article">
        <li
          v-for="item in articleList"
          @click="to(`articleDetail?articleId=${item.articleId}`)"
        >
          <div class="articleRight">
            <div class="articleTitle">{{ item.title }}</div>
            <!--                        <div class="articleContent">{{item.content}}</div>-->
            <div class="nameBox" style="justify-content: space-between">
              作者：{{ item.author }} <span>{{ item.readCount }}浏览</span>
            </div>
          </div>
          <div
            class="articleImg"
            :style="{
              background: `url(${EnvUrl}${item.pic}) no-repeat center/cover`,
            }"
          ></div>
        </li>
      </ul>
    </div>
    <footerBox active="1"></footerBox>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";

import noMoreData from "components/no-more-data";
import newsTopBox from "components/newsTopBox";
import footerBox from "components/footer";
import { Swiper, Slide } from "vue-swiper-component";
import moment from "moment/moment";
import { telDredge } from '../utils/index'

export default {
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      microBannerList: [],
      bespeakAbled: 0,
      campusLocation: "全部",
      companyId: "",
      doctorList: [],
      microList: [],
      articleList: [],
      musicList: [],
      doctorCampusList: [],
      scaleGroupCombo: "",
      scaleGroup: "",
      showScaleGroup: "",
    };
  },
  components: {
    noMoreData,
    Swiper,
    footerBox,
    Slide,
    newsTopBox,
  },
  watch: {
    $route(to, from) {
      this.getDoctorList();
      this.getScaleGroupCombo();
    },
  },
  filters: {
    time(value) {
      let transTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
      return transTime;
    },
    month(value) {
      return `${moment(value).format("MM")}月`;
    },
    isDuration(value) {
      let result = parseInt(value);
      let h =
        Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      let m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      let s =
        Math.floor(result % 60) < 10
          ? "0" + Math.floor(result % 60)
          : Math.floor(result % 60);

      let res = "";
      if (h !== "00") res += `${h}:`;
      if (m !== "00") res += `${m}:`;
      res += `${s}`;
      return res;
    },
  },
  beforeRouteLeave(to, from, next) {
    // 从列表页去到别的页面，如果不是详情页，则不缓存列表页
    if (to.name !== "stockInfo") {
      this.$route.meta.keepAlive = false;
    } else {
      this.$route.meta.keepAlive = true;
    }
    next();
  },
  computed: {},
  methods: {
    clickMe(n) {
      if (n) {
        window.onpageshow = null;
        window.onpageshow = function (event) {
          location.reload();
        };
        if (n.indexOf("http") == 0) {
          window.location.href = n;
        } else {
          window.location.href = location.origin + "/student/" + n;
        }
      }
    },
    async getMicroList() {
      let data = await getSources("/bear-scale/api/micro/getMicroList.json", {
        pageIndex: 1,
        pageSize: 4,
        isRecommended: 1,
        companyId: localStorage.getItem("companyId")
          ? localStorage.getItem("companyId")
          : "",
      });
      console.log(55123123, data);
      if (data.status === 0) {
        this.microList = data.microList;
      } else {
        alert(data.msg);
      }
    },
    async getArticleList() {
      let data = await getSources("/bear-scale/api/micro/getArticleList.json", {
        pageIndex: 1,
        pageSize: 4,
        isRecommended: 1,
        companyId: localStorage.getItem("companyId")
          ? localStorage.getItem("companyId")
          : "",
      });
      if (data.status === 0) {
        this.articleList = data.articleList;
      } else {
        alert(data.msg);
      }
    },
    changeBespeakAbled(n) {
      this.bespeakAbled = n;
      this.getDoctorList();
    },
    changeCampusLocation(n) {
      this.campusLocation = n;
      this.getDoctorList();
    },
    async getDoctorList() {
      let obj = {};
      obj.pageIndex = 1;
      obj.pageSize = 3;
      obj.isRecommended = 1;
      obj.bespeakAbled = this.bespeakAbled;
      obj.campusLocation =
        this.campusLocation == "全部" ? "" : this.campusLocation;
      // obj.companyId = localStorage.getItem("companyId")
      //   ? localStorage.getItem("companyId")
      //   : "";
      obj.companyId = "1001";
      let data = await getSources(
        "/bear-scale/api/chatDoctor/getDoctorList.json",
        obj
      );
      if (data.status === 0) {
        this.doctorList = data.doctorList;
        if (data.doctorCampusList.length > 0) {
          this.doctorCampusList = ["全部", ...data.doctorCampusList];
        }
      } else {
        alert(data.msg);
      }
    },
    async getScaleBannerList() {
      let data = await getSources(
        "/bear-scale/api/micro/getMicroBannerList.json",
        {}
      );
      if (data.status === 0) {
        this.microBannerList = data.microBannerList;
      } else {
        alert(data.msg);
      }
    },
    async getMusicList() {
      let data = await getSources(
        "/bear-scale/api/microMusic/getMusicList.json",
        { type: 1 }
      );
      if (data.status === 0) {
        this.musicList = data.musicList;
      } else {
        alert(data.msg);
      }
    },
    async getScaleGroupCombo() {
      // let data = await getSources("/bear-scale/api/scaleGroup/getScaleGroupCombo.json",{
      //     userId:localStorage.getItem('userId')?localStorage.getItem('userId'):''
      // });
      // if (data.status === 0) {
      //     this.scaleGroup=data.scaleGroup
      //     this.scaleGroupCombo=data.scaleGroupCombo
      //     this.showScaleGroup=data.showScaleGroup
      // }else{
      //     // alert(data.msg)
      // }
    },
    signOut() {
      localStorage.removeItem("userId");
      localStorage.removeItem("roleId");
      localStorage.removeItem("doctorId");

      if (!localStorage.getItem("userId")) {
        this.$router.push(`/login`);
      } else {
        setTimeout(() => {
          this.$router.push(`/login`);
        }, 200);
      }
    },
    to(n) {
      this.$router.push(`/${n}`);
    },
    gotoCulinarian() {
      let doctorId = 449
      if (location.href.indexOf('student.ysqingxin.com') >= 0) doctorId = 449
      if (location.href.indexOf('student-test.ysqingxin.com') >= 0) doctorId = 462
      this.$router.push(`/expertDetail?doctorId=${doctorId}`);
    },
    gotoMiyou() {
      location.href = 'https://page.xlmyai.com/index.html?p=bqW2Vfj4a5GfF7ufa1XcN3tvJ1T8NcEaM3TdQ23q'
    },
    gotoUsOnline() {
      location.href = 'https://intelcc-user.icsoc.net?channelKey=ce96506cc4ebcf3d4bfbbecbd5290917&init=1'
    },
    init() {
      this.getScaleBannerList();
      this.getDoctorList();
      this.getMicroList();
      this.getArticleList();
      this.getMusicList();
      this.getScaleGroupCombo();
    },
    telDredge() {
      return telDredge()
    }
  },
  mounted() {
    // if(!localStorage.getItem('userId')){
    //     if(this.$route.query.code){
    //         this.$router.push(`/login?next=${encodeURIComponent(this.$route.fullPath)}&code=${this.$route.query.code}`)
    //     }else{
    //         this.$router.push(`/login?next=${encodeURIComponent(this.$route.fullPath)}`)
    //     }
    // }
    localStorage.setItem(
      "companyId",
      this.$route.query.id
        ? this.$route.query.id
        : localStorage.getItem("companyId")
        ? localStorage.getItem("companyId")
        : ""
    );
    this.init();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/index.vue?bff4a026